<template>
  <div class="el-list gambit-list">
    <h3
      align="center"
      class="bold"
    >{{ list.Name }}</h3>
    <div class="introduction">
      <div
        ref="imageContainer"
        class="left"
      >
        <!-- <img :src="url" alt=""> -->
      </div>
      <!--<div class="right scroll-container"  v-bind:class="{person:imgType==2}">-->
      <div
        ref="rightContent"
        class="right scroll-container"
      >
        <p 
          v-if="textContent"
          :class="{
            'summary': computeHeight(),
            'text-ellipsis': textEclipsis
          }"
        >
          <span class="bold">简介:</span>
          <span
            v-html="textContent"
          />
        </p>
        <div class="view-detail">

          <div
            style="float:right"
            @click="viewDetail"
          >详情</div>
        </div>
      </div>


    </div>
    <div style="clear:both;" />
    <ul>
      <li
        v-for="(item, index) in list.Data"
        :key="index"
        class="base-border"
      >
        <h5 class="title-text">
          <span>{{ item.PropName }}</span>
          <span
            v-if="item.Count > 5"
            class="float-right el-more"
            @click="columnsList(item)"
          >更多&gt;&gt;</span>
        </h5>
        <p
          v-for="(child, childIndex) in item.Documents"
          :key="childIndex"
          class="list-item"
        >
          <span @click="viewArticle(child)">{{ child.DocName }}</span>
          <img
            v-if="child.Locked && !isLogin"
            class="name-lock"
            src="../../assets/img/lock.png"
          >
          <span class="date float-right">{{ showTime(child) }}</span>
          <!--<span class="date float-right">{{child.PublishTime}}</span>-->
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'GambitMore',
  props: ['list', 'imgType'],
  data () {
    return {
      currentPage: 1,
      downloadImage: window.dataUrl.TopicManage.downloadImage,
      url: '',
      textContent: '',
      textEclipsis: false
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  mounted () {
    var me = this
    var newImg = new Image()
    newImg.src = this.downloadImage + this.list.PicUrl
      // newImg.src='http://localhost/1.jpg'

    newImg.onerror = (error) => {
      console.log(error)
    }
    newImg.onload = () => {
      me.url = newImg.src
      var maxWidth = 286
      var maxHeight = 192

      var width = newImg.naturalWidth
      var height = newImg.naturalHeight

      // 根据原图计算压缩后宽高，最大宽度不超过286，最大高度不超过192
      function cal (width, height) {
        let newWidth = width
        let newHeight = height
        // 宽度压缩
        if (width > maxWidth) {
          newWidth = maxWidth
          newHeight = maxWidth / width * height
        } else if (height > maxHeight) {
          newWidth = maxHeight / height * width
          newHeight = maxHeight
        }
        // 如果压缩后还超出则继续压缩
        if (newHeight > maxHeight || newWidth > maxWidth) {
          return cal(newWidth, newHeight)
        }
        return {
          newWidth,
          newHeight
        }
      }

      let {newWidth, newHeight} = cal(width, height)

      newImg.style.width = newWidth + 'px'
      newImg.style.height = newHeight + 'px'

      // 垂直居中
      newImg.style.marginTop = ((maxHeight - newHeight) / 2) + 'px'
      // 水平居中
      me.$refs.imageContainer.style.marginLeft = ((maxWidth - newWidth) / 2) + 'px'
      me.$refs.imageContainer.appendChild(newImg)
    }

    me.textContent = me.getContent(me.list.Description)
    window.addEventListener('resize', function () {
      me.textContent = me.getContent(me.list.Description)
    })
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    // 计算简介高度是否超出-如果超出则加超出样式 text-ellipsis
    computeHeight () {
      setTimeout(() => {
        const dom = document.querySelector('.summary')
        if (dom) {
          this.textEclipsis = dom.scrollHeight > dom.clientHeight
        }
      }, 300)
      return true
    },
    getContent (content) {
        // var content  = '简介: 走出“文化大革命”十年浩劫的中国，无比热切地呼唤着民主和法制。/<br/>“为了保障人民民主，&nbsp;&nbsp;必须加强法制。必须使民主制度化、法律化，使这种制度和法律不因领导人的改变而改变，不因领导人的看法和注意力的改变而改变。”1978年12月，邓小平在中共中央工作会议上掷地有声的讲话，拨正了法制建设航向。十一届三中全会郑重地提出健全社会主义法制的伟大任务，确立了“有法可依，有法必依，执法必严，违法必究”的社会主义法制建设的十六字方针，为社会主义法制建设开启了崭新征程。１９７９年３月，全国人大常委会法制委员会刚刚成立，就着手选举法、地方组织法、人民法院组织法、人民检察院组织法、刑法、刑事诉讼法和中外合资经营企业法等的修改和起草，创造了４个月制定７部法律的立法佳话，迈出了社会主义民主法制建设的重大步伐。'

      if (content) {
        content = content.replace('<br/>', '').replace('<br>', '')
          // 找出 &nbsp;的数量
        var count = 0
        var i = 0

        var contenLength = content.length
        while (i < contenLength) {
          if (content.substring(i, i + 6) === '&nbsp;') {
            count++
            i += 6
          } else {
            i++
          }
        }
          // alert(count);
        contenLength = contenLength - count * 5
        var maxTextCount = 280
        var bodyWidth = window.document.body.getBoundingClientRect().width
        if (bodyWidth < 1200) {
          maxTextCount = 115
        } else if (bodyWidth > 1400) {
          maxTextCount = 350
        }
        if (contenLength > maxTextCount) {
          content = content.substring(0, maxTextCount) + '....'
        }
      }
      return content
    },
    columnsList (item) {
      let url = this.$route.path + '/' + item.PropType
      this.$router.push({
        path: url,
        query: {
          title: this.$route.query.title
        }
      })
    },
    viewArticle (item) {
      if (item.Locked && !this.isLogin) {
        this.loginShow()
      } else {
        this.$emit('showArticle', item.Id)
      }
    },
    showTime (item) {
      return window.moment(item.PublishTime).format('YYYY-MM-DD')
    },
      // 查看简介详情页
    viewDetail () {
        // 打开新页面
      sessionStorage.setItem('intro-' + this.list.Id, JSON.stringify(this.list))
      window.open('./index.html#/intro/' + this.list.Id + '?title=' + encodeURIComponent(this.list.Name))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/gambit-list.vue